'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export function useMedia(query) {
  const $ = _c(3);
  const [matches, setMatches] = useState(true);
  let t0;
  let t1;
  if ($[0] !== query) {
    t0 = () => {
      const matchMedia = window.matchMedia(query);
      setMatches(matchMedia.matches);
      const handleChange = () => setMatches(matchMedia.matches);
      matchMedia.addEventListener("change", handleChange);
      return () => {
        matchMedia.removeEventListener("change", handleChange);
      };
    };
    t1 = [query];
    $[0] = query;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return matches;
}